<template>
<div class="chapter">
<div class="inner_page">
<p class="subtitle"><a id="page_iii"></a>THREE POWERFUL WAYS TO OVERCOME CHALLENGES IN WORK AND LIFE</p>
<h1 class="h1">Be the Hero</h1>
<p class="author">NOAH BLUMENTHAL</p>
<p class="author1">Foreword by Marshall Goldsmith</p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch0003_title.vue?02254a0a